import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useChatList } from '../../hooks/useChatList';

import { ChatListContent } from './components/ChatListContent';
import { ChatListHeader } from './components/ChatListHeader';
import { SearchActionsBar } from './components/SearchActionsBar';

interface ChatListProps {}

export const ChatList: React.FC<ChatListProps> = () => {
  const navigate = useNavigate();

  const {
    chats,
    isLoading,
    currentPage,
    totalPages,
    searchTerm,
    filters,
    handleSearch,
    handleFilterChange,
    handlePageChange,
    handleChatToggle,
  } = useChatList();

  useEffect(() => {
    document.title = 'Chat list - Choco Admin';
  }, []);

  const handleCreateChat = () => {
    navigate('/chats/create');
  };

  return (
    <div className="p-6 min-h-screen bg-background">
      <ChatListHeader onCreateChat={handleCreateChat} />

      <SearchActionsBar
        onFilterChange={handleFilterChange}
        defaultSearchInputValue={searchTerm}
        onSearchInputChange={handleSearch}
        currentFilters={filters}
      />

      <ChatListContent
        chats={chats}
        isLoading={isLoading}
        currentPage={currentPage}
        totalPages={totalPages}
        onChatToggle={handleChatToggle}
        onNextPageClick={() => {
          if (currentPage < totalPages) {
            handlePageChange(currentPage + 1);
          }
        }}
        onPreviousPageClick={() => {
          if (currentPage > 1) {
            handlePageChange(currentPage - 1);
          }
        }}
      />
    </div>
  );
};
